module.exports = __webpack_public_path__ + "img/step-05-shield.1fc34598.svg";